/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { MultiIoDetails } from "./MultiIoDetails.ts";
import type { TokenTransactionMetadata } from "./TokenTransactionMetadata.ts";
import type { TransactionParty } from "./TransactionParty.ts";

export const tokenTransactionStatusEnum = {
	confirmed: "confirmed",
	pending: "pending",
	failed: "failed",
	expired: "expired",
} as const;

export type TokenTransactionStatusEnum =
	(typeof tokenTransactionStatusEnum)[keyof typeof tokenTransactionStatusEnum];

export type TokenTransaction = {
	/**
	 * @type string
	 */
	id: string;
	/**
	 * @description Transaction type
	 * @type string
	 */
	type: string;
	/**
	 * @type string
	 */
	status: TokenTransactionStatusEnum;
	/**
	 * @description When the transaction was first created/broadcast.
	 * @type string, date-time
	 */
	createdAt?: string | null;
	/**
	 * @description Last update / completion timestamp.
	 * @type string, date-time
	 */
	updatedAt?: string | null;
	/**
	 * @description Sender information. May be null for multi-output transactions.
	 * @type object
	 */
	from?: TransactionParty | null;
	/**
	 * @description Receiver information. May be null for multi-output transactions.
	 * @type object
	 */
	to?: TransactionParty | null;
	/**
	 * @description Total output amount for the transaction
	 * @type integer
	 */
	amount: number;
	/**
	 * @type number, float
	 */
	valueUsd: number;
	/**
	 * @type object
	 */
	tokenMetadata: TokenTransactionMetadata;
	/**
	 * @description Details for multi-input/output transactions
	 * @type object
	 */
	multiIoDetails?: MultiIoDetails | null;
};
